/** @jsxImportSource @emotion/react */
import React, { useState, useEffect } from "react";
import { css, useTheme } from "@emotion/react";
import { useLanguage } from "LanguageContext";

interface FilterChipSelectorProps {
  items: string[]; // Dynamic chip items
  selectedTag?: string;
  onTagChange: (tag: string) => void;
}

const FilterChipSelector: React.FC<FilterChipSelectorProps> = ({ items, selectedTag, onTagChange }) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  const { t } = useLanguage();
  const theme = useTheme();

  useEffect(() => {
    if (selectedTag) {
      setSelectedValue(selectedTag);
    }
  }, [selectedTag]);

  const handleTagChange = (tag: string) => {
    setSelectedValue(tag);
    onTagChange(tag);
  };

  const chipGroupStyle = css`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  `;

  const chipItemStyle = css`
    font-weight: 600;
    padding: 4px 12px;
    border: 2px solid #ccc;
    border-radius: 20PX;
    cursor: pointer;
    transition: background 0.2s ease, border 0.2s ease;
    background: #fff;
  `;

  const selectedChipStyle = (theme: any) => css`
    background: ${theme.colors.primary || "#007bff"};
    color: #fff;
    border-color: ${theme.colors.primary || "#007bff"};
  `;

  const tagOptions: Record<string, string> = {
    Vague: "feedback_tagNotPrecise",
    Wrong: "feedback_tagWrong",
    Irrelevant: "feedback_tagPasPertinent",
  };

  return (
    <div css={chipGroupStyle}>
      {items?.map((tag) => (
        <button
          key={tag}
          css={[chipItemStyle, selectedValue === tag ? selectedChipStyle(theme) : null]}
          onClick={() => handleTagChange(tag)}
        >
          {t(tagOptions[tag as keyof typeof tagOptions] ?? tag)}
        </button>
      ))}
    </div>
  );
};

export default FilterChipSelector;
